function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b4b4b4;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1 -1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M30.872,7H20.418a.418.418,0,1,0,0,.836H30.872a.418.418,0,1,0,0-.836Z",
  transform: "translate(-10.29 -3.491)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M7.272,1H3.927a.418.418,0,0,0-.418.418V3.509H1.418a.418.418,0,1,0,0,.836H3.509V6.436a.418.418,0,0,0,.418.418H7.272a.418.418,0,0,0,.418-.418V1.418A.418.418,0,0,0,7.272,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M1.418,23H11.872a.418.418,0,0,1,0,.836H1.418a.418.418,0,0,1,0-.836Z",
  transform: "translate(0 -12.418)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M31.418,17h3.345a.418.418,0,0,1,.418.418v2.091h2.091a.418.418,0,1,1,0,.836H35.181v2.091a.418.418,0,0,1-.418.418H31.418A.418.418,0,0,1,31,22.436V17.418A.418.418,0,0,1,31.418,17Z",
  transform: "translate(-16.69 -8.927)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M30.872,39H20.418a.418.418,0,1,0,0,.836H30.872a.418.418,0,1,0,0-.836Z",
  transform: "translate(-10.29 -21.345)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M7.272,33H3.927a.418.418,0,0,0-.418.418v2.091H1.418a.418.418,0,1,0,0,.836H3.509v2.091a.418.418,0,0,0,.418.418H7.272a.418.418,0,0,0,.418-.418V33.418A.418.418,0,0,0,7.272,33Z",
  transform: "translate(0 -17.854)"
}));

var SvgPreferences = function SvgPreferences(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreferences, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preferences.ede54e2b.svg";
export { ForwardRef as ReactComponent };